import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React, { useContext, useMemo } from "react";
import { RiArrowDropRightLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { Context as BreadcrumbContext } from "./Provider";

export const BreadcrumbRender = () => {
  const breadcrumbContext = useContext(BreadcrumbContext);
  const bgColor = useColorModeValue("gray.100", "gray.800");
  const color = useColorModeValue("gray.700", "gray.200");

  const breadcrumb: React.ReactNode[] = useMemo(() => {
    const qtd = breadcrumbContext.paths.length;
    const result: React.ReactNode[] = [];

    breadcrumbContext.paths.forEach((x, i) => {
      if (i > 0) {
        result.push(
          <Text key={x.name + x.link + i} px="2" color={color}>
            <RiArrowDropRightLine size="1.3rem" />
          </Text>
        );
      }

      x.link != null
        ? result.push(
            <Box
              key={x.name + x.link}
              color={color}
              as={Link}
              to={x.link}
              fontWeight="light"
              _hover={{ textDecoration: "underline" }}
            >
              {x.name}
            </Box>
          )
        : result.push(
            <Box
              key={x.name + x.link}
              as="span"
              fontWeight={qtd == i + 1 ? "medium" : "normal"}
            >
              {x.name}
            </Box>
          );
    });

    return result;
  }, [breadcrumbContext.paths, color]);

  return (
    <Flex
      bgColor={bgColor}
      w="100%"
      top="0"
      alignItems="center"
      fontSize="0.8rem"
      fontWeight="medium"
      py="1.5"
    >
      <Flex px={6}>{breadcrumb}</Flex>
    </Flex>
  );
};
